import { useWebsiteKeywordsPageTableTopContext } from "../WebsiteKeywordsPageContext";

import type { IChangeFilterItems } from "app/components/filters-bar/change-filter/ChangeFilter";
import { ChangeFilter } from "app/components/filters-bar/change-filter/ChangeFilter";

interface IChangeFilterForWebsiteKeywordsProps {
    changeFilterItems: IChangeFilterItems[];
}

export const ChangeFilterForWebsiteKeywords = ({ changeFilterItems }: IChangeFilterForWebsiteKeywordsProps) => {
    const { tableFilters, onChangeFilterChange } = useWebsiteKeywordsPageTableTopContext();
    return (
        <ChangeFilter
            onChangeFilterChange={onChangeFilterChange}
            selectedValue={tableFilters.Change}
            changeFilterItems={changeFilterItems}
        />
    );
};
